import React, { useState } from 'react';
import { trackEvent } from '../utils/analytics';

const API = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSignup = ({ source = 'site' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    try {
      const res = await fetch(`${API}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), source }),
      });
      const data = await res.json();
      if (!res.ok) {
        setStatus('error');
        setMessage(data.detail || 'Something went wrong. Please try again.');
        return;
      }
      if (data.status === 'already') {
        setStatus('done');
        setMessage(data.message);
      } else {
        setStatus('done');
        setMessage(data.message);
        trackEvent('newsletter_signup', { source });
      }
    } catch (err) {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div
      id="newsletter"
      data-testid="newsletter-signup"
      className="bg-[#F5F5DC] text-black rounded-xl px-5 py-5 max-w-xl mx-auto scroll-mt-24"
    >
      <p className="text-base font-medium text-black mb-1">A weekly article to stimulate the mind</p>
      <p className="text-sm text-black/70 mb-3">
        Critical Thinking to start your week. No spam. No sales. No credit card
      </p>
      {status === 'done' ? (
        <p data-testid="newsletter-result" className="text-sm font-medium">{message}</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            data-testid="newsletter-email-input"
            className="flex-1 px-4 py-2 rounded-md bg-white text-black placeholder-black/40 border border-black/20 focus:outline-none focus:border-black/60 text-sm"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            data-testid="newsletter-submit-btn"
            className="px-6 py-2 rounded-md bg-black text-[#F5F5DC] text-sm font-medium hover:bg-black/80 transition-colors disabled:opacity-60"
          >
            {status === 'loading' ? 'Joining' : 'Subscribe'}
          </button>
        </form>
      )}
      {status === 'error' && (
        <p data-testid="newsletter-error" className="text-sm text-red-700 mt-2">{message}</p>
      )}
    </div>
  );
};

export default NewsletterSignup;
